import type { ApiResponse } from '../models/ApiResponse';
import BaseService from './BaseService';

class InfoService extends BaseService {
  public static getBackendVersion(): Promise<ApiResponse<string>> {
    return this.get('/v1/version');
  }

  public static ping(ping: string, signal?: AbortSignal): Promise<ApiResponse<string>> {
    return this.get('/v1/ping', { params: { ping }, signal });
  }
}

export default InfoService;
